import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function seekingsRoutes($stateProvider: StateProvider) {
    let seekedSeekings: {default: any};
    let providedSeekings: {default: any};

    $stateProvider
        .state('seeked-seekings', {
            name: 'seeked-seekings',
            url: '/seeked-seekings',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => seekedSeekings.default
            },
            lazyLoad: async () => {
                seekedSeekings = await import(/* webpackChunkName: "seekedSeekings" */ './KpSeekedSeekingsPage.svelte');
                return null;
            }
        })
        .state('provided-seekings', {
            name: 'provided-seekings',
            url: '/provided-seekings',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => providedSeekings.default
            },
            lazyLoad: async () => {
                providedSeekings = await import(/* webpackChunkName: "providedSeekings" */ './KpProvidedSeekingsPage.svelte');
                return null;
            }
        });
}